import { Module } from './Module';

export interface MessageCallback {
	(data? : any) : boolean | undefined;
}

interface ModuleReference {
	component : Module
}

export class Connector {
	public components : {[id : string] : ModuleReference} = {};

	public connectorId : string;

	/**
	 * Initializes the Connector.
	 *
	 * @method init
	 * @constructor
	 * @param {String} connectorId
	 *      The unique connector ID
	 */
	constructor(connectorId : string) {
		this.connectorId = connectorId;
	}

	/**
	 * Registers a component.
	 *
	 * @method registerComponent
	 * @param {Module} component
	 *      The module to register
	 */
	public registerComponent(component : Module) {
		this.components[component.id] = {component};
	}

	/**
	 * Unregisters a component.
	 *
	 * @method unregisterComponent
	 * @param {Module} component
	 *      The module to unregister
	 */
	public unregisterComponent(component : Module) {
		const components = this.components;

		if (components[component.id]) {
			// tslint:disable-next-line:no-dynamic-delete
			delete components[component.id];
		}
	}

	/**
	 * Notifies all registered components about a state change
	 * This can be be overriden in the specific connectors.
	 *
	 * @method notify
	 * @param {Module} origin
	 *      The module that sends the state change
	 * @param {String} state
	 *      The component's state
	 * @param {Object} data
	 *      Contains the state relevant data (if any)
	 * @return {boolean}
	 *      Indicates whether the default action should be excuted or not
	 */
	public notify(origin : Module, state : string, data : any) {
		/*
		 * Gives the components the ability to prevent the default- and
		 * after action from the events by returning false in the
		 * on {Event}-Handler.
		 */
		let proceed = true;
		const components = this.components;

		for (const id in components) {
			const component = components[id].component;
			if (component === origin) {
				continue;
			}
			const callback : MessageCallback = (component as any)[state];
			if(!callback) {
				continue;
			}
			const result = !!callback.call(component, data);
			if (!result) {
				proceed = false;
			}
		}

		return proceed;
	}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/vendor/terrific/Connector.ts